import dict from "@/common/js/dict";
import globalData from "@/common/js/globalData";
import util from "@/common/js/util";
import constants from "@/common/constants";
/**
 * 区域选择
 */
import region from "@/common/api/region";
import addressCode from "@/common/api/addressCode";
import category from "@/common/api/category";
import fclunit from "@/common/api/fclunit";
import currency from "@/common/api/currency";
import carrier from "@/common/api/carrier";
import channel from "@/common/api/channel";
import worldPort from "@/common/api/worldPort";
import store from "@/common/api/store";
import allunit from "@/common/api/allunit";
import customerLevel from "@/common/api/customerLevel";
import country from "@/common/api/country";
import platform from "@/common/api/platform";
/**
 * 操作选项
 */
export let BarOpt = class {
    constructor(opt, title, valueForm, valueFormAttr, valueRequired = true) {
        this.opt = opt;
        this.title = title;
        this.valueForm = valueForm;
        this.valueFormAttr = valueFormAttr;
        this.valueRequired = valueRequired;
    }
}

/**
 * 下拉框选项
 */
class SelectOption {
    constructor(label, value) {
        this.label = label;
        this.value = value;
    }
}


let equalsSelectFactory = attribute => [
    new BarOpt("equals", "等于", "select", attribute),
]


/**
 * 合作方式规则选择
 */
export const cooperationRuleSelect = equalsSelectFactory({
    dataFetch: key => ([
        new SelectOption('营业额', 1),
        new SelectOption('委托单毛利', 0),
    ]), storeKey: 'cooperationRuleSelect'
});


export const regionSelect = [
    new BarOpt("startWith", "包含", "cascader", {
        storeKey: 'regionSelect',
        dataFetch: async key => {
            return await region.getList();
        },
    }),
];


export const categorySelect = [
    new BarOpt("in", "属于", "select", {
        storeKey: 'categorySelect',
        dataFetch: async key => {
            return await category.getList();
        },
        multiple: true ,
        filterable: true
    }),
    new BarOpt("notIn", "不属于", "select", {
        storeKey: 'categorySelect',
        dataFetch: async key => {
            return await category.getList();
        },
        multiple: true ,
        filterable: true
    }),
]

export const currencySelect = [
    new BarOpt("in", "属于", "select", {
        storeKey: 'currencySelect',
        dataFetch: async key => {
            return await currency.getList();
        },
        multiple: true ,
        filterable : true
    }),
    new BarOpt("notIn", "不属于", "select", {
        storeKey: 'currencySelect',
        dataFetch: async key => {
            return await currency.getList();
        },
        multiple: true ,
        filterable : true
    }),
]

export const carrierSelect = [
    new BarOpt("equals", "等于", "select", {
        storeKey: 'carrierSelect',
        dataFetch: async key => {
            return await carrier.getList();
        },
        filterable : true
    }),
    new BarOpt("notEquals", "不等于", "select", {
        storeKey: 'carrierSelect',
        dataFetch: async key => {
            return await carrier.getList();
        },
        filterable : true
    }),
    new BarOpt("in", "属于", "select", {
        storeKey: 'carrierSelect',
        dataFetch: async key => {
            return await carrier.getList();
        },
        multiple: true ,
        filterable : true
    }),
    new BarOpt("notIn", "不属于", "select", {
        storeKey: 'carrierSelect',
        dataFetch: async key => {
            return await carrier.getList();
        },
        multiple: true,
        filterable: true
    }),
]


export const countrySelect = [
    new BarOpt("equals", "等于", "select", {
        storeKey: 'countrySelect',
        dataFetch: async key => {
            return await country.getList();
        },
        filterable: true
    }),
    new BarOpt("notEquals", "不等于", "select", {
        storeKey: 'countrySelect',
        dataFetch: async key => {
            return await country.getList();
        },
        filterable: true
    }),
    new BarOpt("in", "属于", "select", {
        storeKey: 'countrySelect',
        dataFetch: async key => {
            return await country.getList();
        },
        multiple: true,
        filterable: true
    }),
    new BarOpt("notIn", "不属于", "select", {
        storeKey: 'countrySelect',
        dataFetch: async key => {
            return await country.getList();
        },
        multiple: true ,
        filterable : true
    }),
]

export const platformSelect = [
    new BarOpt("equals", "等于", "select", {
        storeKey: 'platformSelect',
        dataFetch: async key => {
            return await platform.getList();
        },
        filterable : true
    }),
    new BarOpt("notEquals", "不等于", "select", {
        storeKey: 'platformSelect',
        dataFetch: async key => {
            return await platform.getList();
        },
        filterable : true
    }),
    new BarOpt("in", "属于", "select", {
        storeKey: 'platformSelect',
        dataFetch: async key => {
            return await platform.getList();
        },
        multiple: true ,
        filterable : true
    }),
    new BarOpt("notIn", "不属于", "select", {
        storeKey: 'platformSelect',
        dataFetch: async key => {
            return await platform.getList();
        },
        multiple: true ,
        filterable : true
    }),
]


export const channelSelect = [
    new BarOpt("equals", "等于", "select", {
        storeKey: 'channelSelect',
        dataFetch: async key => {
            return await channel.getList();
        },
        filterable : true
    }),
    new BarOpt("notEquals", "不等于", "select", {
        storeKey: 'channelSelect',
        dataFetch: async key => {
            return await channel.getList();
        },
        filterable : true
    }),
    new BarOpt("in", "属于", "select", {
        storeKey: 'channelSelect',
        dataFetch: async key => {
            return await channel.getList();
        },
        multiple: true ,
        filterable : true
    }),
    new BarOpt("notIn", "不属于", "select", {
        storeKey: 'channelSelect',
        dataFetch: async key => {
            return await channel.getList();
        },
        multiple: true ,
        filterable : true
    }),
]

export const worldPortSelect = [
    new BarOpt("equals", "等于", "select", {
        storeKey: 'worldPortSelect',
        dataFetch: async key => {
            return await worldPort.getList();
        },
        filterable : true
    }),
    new BarOpt("notEquals", "不等于", "select", {
        storeKey: 'worldPortSelect',
        dataFetch: async key => {
            return await worldPort.getList();
        },
        filterable : true
    }),
    new BarOpt("in", "属于", "select", {
        storeKey: 'worldPortSelect',
        dataFetch: async key => {
            return await worldPort.getList();
        },
        multiple: true ,
        filterable : true
    }),
    new BarOpt("notIn", "不属于", "select", {
        storeKey: 'worldPortSelect',
        dataFetch: async key => {
            return await worldPort.getList();
        },
        multiple: true ,
        filterable : true
    }),
]




export const fclUnitSelect = [
    new BarOpt("equals", "等于", "select", {
        storeKey: 'fclUnitSelect',
        dataFetch: async key => {
            return await fclunit.getList();
        },
        filterable : true
    }),
    new BarOpt("notEquals", "不等于", "select", {
        storeKey: 'fclUnitSelect',
        dataFetch: async key => {
            return await fclunit.getList();
        },
        filterable : true
    }),
    new BarOpt("in", "属于", "select", {
        storeKey: 'fclUnitSelect',
        dataFetch: async key => {
            return await fclunit.getList();
        },
        multiple: true ,
        filterable : true
    }),
    new BarOpt("notIn", "不属于", "select", {
        storeKey: 'fclUnitSelect',
        dataFetch: async key => {
            return await fclunit.getList();
        },
        multiple: true ,
        filterable : true
    }),
]


export const allUnitSelect = [
    new BarOpt("equals", "等于", "select", {
        storeKey: 'allUnitSelect',
        dataFetch: async key => {
            return await allunit.getList();
        },
        filterable : true
    }),
    new BarOpt("notEquals", "不等于", "select", {
        storeKey: 'allUnitSelect',
        dataFetch: async key => {
            return await allunit.getList();
        },
        filterable : true
    }),
    new BarOpt("in", "属于", "select", {
        storeKey: 'allUnitSelect',
        dataFetch: async key => {
            return await allunit.getList();
        },
        multiple: true ,
        filterable : true
    }),
    new BarOpt("notIn", "不属于", "select", {
        storeKey: 'allUnitSelect',
        dataFetch: async key => {
            return await allunit.getList();
        },
        multiple: true ,
        filterable : true
    }),
]

export const customerLevelSelect = [
    new BarOpt("equals", "等于", "select", {
        storeKey: 'customerLevelSelect',
        dataFetch: async key => {
            return await customerLevel.getList();
        },
        filterable : true
    }),
    new BarOpt("notEquals", "不等于", "select", {
        storeKey: 'customerLevelSelect',
        dataFetch: async key => {
            return await customerLevel.getList();
        },
        filterable : true
    }),
    new BarOpt("in", "属于", "select", {
        storeKey: 'customerLevelSelect',
        dataFetch: async key => {
            return await customerLevel.getList();
        },
        multiple: true ,
        filterable : true
    }),
    new BarOpt("notIn", "不属于", "select", {
        storeKey: 'customerLevelSelect',
        dataFetch: async key => {
            return await customerLevel.getList();
        },
        multiple: true ,
        filterable : true
    }),
]

let queryPartnerSelect = async name=>{

    let res = await util.axios({
            method: 'post',
            url: 'partner/customer/queryForSelect',
            transformRequest: [data => JSON.stringify(data)],
            headers: {"Content-Type": "application/json; charset=UTF-8"},
            data: {companyFullName: name, businessType: 3 , pageNo: 1, pageSize: 20 }
        }
    );
    return (res.module.lztxRespDTOS || []).map(e => ({
        value: e.id,
        label: e.companyFullName
    }));
}

/**
 * 此组件目前只用在委托人上，所以默认过滤游客
 */
let queryCustomerSelect = async name=>{

    let res = await util.axios({
            method: 'post',
            url: 'partner/customer/queryForSelect',
            transformRequest: [data => JSON.stringify(data)],
            headers: {"Content-Type": "application/json; charset=UTF-8"},
            data: {companyFullName: name, businessType: 1 , pageNo: 1, pageSize: 20, izSea:false }
        }
    );
    return (res.module.lztxRespDTOS || []).map(e => ({
        value: e.id,
        label: e.companyFullName || "-"
    }));
}

let querySupplierSelect = async name=>{

    let res = await util.axios({
            method: 'post',
            url: 'partner/customer/queryForSelect',
            transformRequest: [data => JSON.stringify(data)],
            headers: {"Content-Type": "application/json; charset=UTF-8"},
            data: {companyFullName: name, businessType: 2 , pageNo: 1, pageSize: 20 }
        }
    );
    return (res.module.lztxRespDTOS || []).map(e => ({
        value: e.id,
        label: e.companyFullName
    }));
}

let querySupplierSelectLabel = async name=>{

    let res = await util.axios({
            method: 'post',
            url: 'partner/customer/queryForSelect',
            transformRequest: [data => JSON.stringify(data)],
            headers: {"Content-Type": "application/json; charset=UTF-8"},
            data: {companyFullName: name, businessType: 2 , pageNo: 1, pageSize: 20 }
        }
    );
    return (res.module.lztxRespDTOS || []).map(e => ({
        value: e.companyFullName,
        label: e.companyFullName
    }));
}

let queryUserSelect =  async name=>{

    let res = await util.axios({
            method: 'post',
            url: 'basic/queryAllAccount',
            data: {name: name, pageNo: 1, pageSize: 20 }
        }
    );
    return (res.module || []).map(e => ({
        value: e.key,
        label: e.label,
        key:e.key
    }));
}

let queryUserSelectLabel =  async name=>{

    let res = await util.axios({
            method: 'post',
            url: 'basic/queryAllAccount',
            data: {name: name, pageNo: 1, pageSize: 20 }
        }
    );
    return (res.module || []).map(e => ({
        value: e.label,
        label: e.label,
        key:e.key
    }));
}

let queryAddressSelect = async name=>{

    let res = await util.axios({
            method: 'post',
            url: "public/queryPublicAddress",
            data: {addressCode: name, pageNo: 1, pageSize: 20 }
        }
    );
    return (res.module || []).map(e => ({
        value: e.addressCode,
        label: e.addressCode,
        key:e.addressCode
    }));
}



export const addressCodeSelect = [
    new BarOpt("in", "属于", "select", {
        remoteMethod:queryAddressSelect,
        remote:true,
        multiple: true,
        filterable: true
    }),
    new BarOpt("notIn", "不属于", "select", {
        remoteMethod:queryAddressSelect,
        remote:true,
        multiple: true ,
        filterable: true
    }),
]


let queryStoreSelect =  async name=>{

    let res = await util.axios({
            method: 'post',
            url: 'public/queryPublicStore',
            data: {addressCode: name, pageNo: 1, pageSize: 20,companyId:constants.company.companyId }
        }
    );
    return (res.module || []).map(e => ({
        value: e.addressCode,
        label: e.addressCode,
        key:e.addressCode
    }));
}


export const storeSelect = [
    new BarOpt("equals", "等于", "select", {
        remoteMethod:queryStoreSelect,
        remote:true,
        filterable : true
    }),
    new BarOpt("notEquals", "不等于", "select", {
        remoteMethod:queryStoreSelect,
        remote:true,
        filterable : true
    }),
    new BarOpt("in", "属于", "select", {
        remoteMethod:queryStoreSelect,
        remote:true,
        multiple: true ,
        filterable : true
    }),
    new BarOpt("notIn", "不属于", "select", {
        remoteMethod:queryStoreSelect,
        remote:true,
        multiple: true ,
        filterable : true
    }),
]




function dictDataFetch (dictKey){
    let _dict = dict.dict(dictKey) || [];
    let filter = this?.table?.optFilter?.["dict#" + dictKey];
    return key=>(filter ? _dict.filter(e=>filter(e)) : _dict).map(e => new SelectOption(e, e));
}
function sysDictDataFetch (dictKey){
    let _dict = globalData[dictKey] || [];
    let filter = this?.table?.optFilter?.["sysDict#" + dictKey];
    return key=>(filter ? _dict.filter(e=>filter(e)) : _dict).map(e => new SelectOption(e.label, e.value));
}

/**
 * 操作选项类型和选项值的映射关系
 */
export let barOptionTypeMap = {
    cooperationRuleSelect: {
        name: "ElSelectBar",
        title: '合作方式搜索',
        optList: cooperationRuleSelect
    },
    partnerSelect:{
        name: "ElSelectBar",
        title: '合伙人搜索',
        optList: [
            new BarOpt("equals", "等于", "select",{
                remote:true,
                filterable:true,
                remoteMethod:queryPartnerSelect
            }),
            new BarOpt("notEquals", "不等于", "select", {
                remote:true,
                filterable:true,
                remoteMethod:queryPartnerSelect
            }),
            new BarOpt("in", "属于", "select", {
                remote:true,
                multiple: true ,
                filterable : true ,
                remoteMethod:queryPartnerSelect
            }),
            new BarOpt("notIn", "不属于", "select", {
                remote:true,
                multiple: true ,
                filterable : true ,
                remoteMethod:queryPartnerSelect
            }),
        ]
    },
    customerSelect:{
        name: "ElSelectBar",
        title: '客户搜索',
        optList: [
            new BarOpt("equals", "等于", "select",{
                remote:true,
                filterable:true,
                remoteMethod:queryCustomerSelect
            }),
            new BarOpt("notEquals", "不等于", "select", {
                remote:true,
                filterable:true,
                remoteMethod:queryCustomerSelect
            }),
            new BarOpt("in", "属于", "select", {
                remote:true,
                multiple: true ,
                filterable : true ,
                remoteMethod:queryCustomerSelect
            }),
            new BarOpt("notIn", "不属于", "select", {
                remote:true,
                multiple: true ,
                filterable : true ,
                remoteMethod:queryCustomerSelect
            }),
        ]
    },
    supplerSelectStr:{
        name: "ElSelectBar",
        title: '供应商搜索',
        optList: [
            new BarOpt("equals", "等于", "select",{
                remote:true,
                filterable:true,
                remoteMethod:querySupplierSelect
            }),
            new BarOpt("notEquals", "不等于", "select", {
                remote:true,
                filterable:true,
                remoteMethod:querySupplierSelect
            }),
            new BarOpt("empty","为空","select",{disabled: true}),
            new BarOpt("notEmpty","不为空","select",{disabled: true}),
            new BarOpt("in", "属于", "select", {
                remote:true,
                multiple: true ,
                filterable : true ,
                remoteMethod:querySupplierSelect
            }),
            new BarOpt("notIn", "不属于", "select", {
                remote:true,
                multiple: true ,
                filterable : true ,
                remoteMethod:querySupplierSelect
            }),
        ]
    },
    supplerSelectStrLabel:{
        name: "ElSelectBar",
        title: '供应商搜索',
        optList: [
            new BarOpt("equals", "等于", "select",{
                remote:true,
                filterable:true,
                remoteMethod:querySupplierSelectLabel
            }),
            new BarOpt("notEquals", "不等于", "select", {
                remote:true,
                filterable:true,
                remoteMethod:querySupplierSelectLabel
            }),
            new BarOpt("empty","为空","select",{disabled: true}),
            new BarOpt("notEmpty","不为空","select",{disabled: true}),
            new BarOpt("in", "属于", "select", {
                remote:true,
                multiple: true ,
                filterable : true ,
                remoteMethod:querySupplierSelectLabel
            }),
            new BarOpt("notIn", "不属于", "select", {
                remote:true,
                multiple: true ,
                filterable : true ,
                remoteMethod:querySupplierSelectLabel
            }),
        ]
    },
    supplierSelectJson:{
        name: "ElSelectBar",
        title: '供应商搜索',
        optList: [
            new BarOpt("contains", "等于", "select", {
                remote:true,
                filterable:true,
                remoteMethod:querySupplierSelect
            }),
        ]
    },
    userSelectLabel:{
        name: "ElSelectBar",
        title: '用户搜索',
        optList: [
            new BarOpt("equals", "等于", "select", {
                remote:true,
                filterable:true,
                remoteMethod:queryUserSelectLabel
            }),
            new BarOpt("notEquals", "不等于", "select", {
                remote:true,
                filterable:true,
                remoteMethod:queryUserSelectLabel
            }),

            new BarOpt("in", "属于", "select", {
                remote:true,
                filterable:true,
                remoteMethod:queryUserSelectLabel
            }),
            new BarOpt("notIn", "不属于", "select", {
                remote:true,
                filterable:true,
                remoteMethod:queryUserSelectLabel
            }),
        ]
    },
    userSelect:{
        name: "ElSelectBar",
        title: '用户搜索',
        optList: [
            new BarOpt("equals", "等于", "select", {
                remote:true,
                filterable:true,
                remoteMethod:queryUserSelect
            }),
            new BarOpt("notEquals", "不等于", "select", {
                remote:true,
                filterable:true,
                remoteMethod:queryUserSelect
            }),

            new BarOpt("in", "属于", "select", {
                remote:true,
                filterable:true,
                remoteMethod:queryUserSelect
            }),
            new BarOpt("notIn", "不属于", "select", {
                remote:true,
                filterable:true,
                remoteMethod:queryUserSelect
            }),
        ]
    },
    addressCodeSelect:{
        name: "ElSelectBar",
        title: '选择目的地编码',
        optList: addressCodeSelect
    },
    categorySelect:{
        name: "ElSelectBar",
        title: '选择品类',
        optList: categorySelect
    },
    fclUnitSelect:{
        name: "ElSelectBar",
        title: '选择品类',
        optList: fclUnitSelect
    },
    currencySelect:{
        name: "ElSelectBar",
        title: '选择品类',
        optList: currencySelect
    },
    carrierSelect:{
        name: "ElSelectBar",
        title: '选择承运人',
        optList: carrierSelect
    },
    channelSelect:{
        name: "ElSelectBar",
        title: '选择承运人',
        optList: channelSelect
    },
    worldPortSelect:{
        name: "ElSelectBar",
        title: '选择世界港口',
        optList: worldPortSelect
    },
    allUnitSelect:{
        name: "ElSelectBar",
        title: '选择单位',
        optList: allUnitSelect
    },
    storeSelect:{
        name: "ElSelectBar",
        title: '选择仓库',
        optList: storeSelect
    },
    customerLevelSelect:{
        name: "ElSelectBar",
        title: '选择客户等级',
        optList: customerLevelSelect
    },
    regionSelect: {
        name: "ElCascaderBar",
        title: '地区选择',
        optList: regionSelect
    },
    countrySelect: {
        name: "ElSelectBar",
        title: '国家',
        optList: countrySelect
    },
    platformSelect:{
        name: "ElSelectBar",
        title: '平台',
        optList: platformSelect
    },
    dict(key) {
        let dataFetch = dictDataFetch.call(this,key);
        return {
            name: "ElSelectBar",
            title: '字典搜索' + key,
            optList:[
                new BarOpt("equals", "等于", "select", {
                    dataFetch, storeKey: 'dictList_' + key
                }),
                new BarOpt("in", "属于", "select", {
                    dataFetch , storeKey: 'dictList_' + key,
                    multiple: true
                }),new BarOpt("notIn", "不属于", "select", {
                    dataFetch , storeKey: 'dictList_' + key,
                    multiple: true
                }),
                new BarOpt("isNull","为空","select",{disabled: true},false),
                new BarOpt("notNull","不为空","select",{disabled: true},false)
            ],
            inputAttr:{
                dataFetch: function (key) {
                    return (_dict || []).map(e => new SelectOption(e, e));
                }, storeKey: 'dictList_' + key
            }
        }
    },
    dictList(key) {
        let dataFetch = dictDataFetch.call(this,key);
        return {
            name: "ElSelectBar",
            title: '字典多值包含搜索' + key,
            optList: [new BarOpt("contains", "包含", "select", {
                dataFetch, storeKey: 'dictList_' + key,
                multiple: true
            }),new BarOpt("notContains", "不包含", "select", {
                    dataFetch, storeKey: 'dictList_' + key,
                    multiple: true
                }),new BarOpt("in", "属于", "select", {
                dataFetch, storeKey: 'dictList_' + key,
                multiple: true
            }),new BarOpt("notIn", "不属于", "select", {
                dataFetch, storeKey: 'dictList_' + key,
                multiple: true
            })],
            inputAttr:{
                dataFetch, storeKey: 'dictList_' + key,
                multiple: false
            }
        }
    },
    dictListContain(key) {
        let dataFetch = dictDataFetch.call(this,key);
        return {
            name: "ElSelectBar",
            title: '字典多值包含搜索' + key,
            optList: [new BarOpt("contains", "包含", "select", {
                dataFetch, storeKey: 'dictList_' + key,
                multiple: true
            }),new BarOpt("notContains", "不包含", "select", {
                dataFetch, storeKey: 'dictList_' + key,
                multiple: true
            })],
            inputAttr:{
                dataFetch, storeKey: 'dictList_' + key,
                multiple: false
            }
        }
    },
    dictListInOrNotIn(key) {
        let dataFetch = dictDataFetch.call(this,key);
        return {
            name: "ElSelectBar",
            title: '字典多值包含搜索' + key,
            optList: [
                new BarOpt("in", "属于", "select", {
                dataFetch, storeKey: 'dictList_' + key,
                multiple: true
            }),new BarOpt("notIn", "不属于", "select", {
                dataFetch, storeKey: 'dictList_' + key,
                multiple: true
            })],
            inputAttr:{
                dataFetch, storeKey: 'dictList_' + key,
                multiple: false
            }
        }
    },
    sysDict(key) {
        let dataFetch = sysDictDataFetch.call(this,key);
        return {
            name: "ElSelectBar",
            title: '系统字典单值匹配' + key,
            optList: [
                new BarOpt("equals", "等于", "select",  {
                    dataFetch, storeKey: 'sysDict_' + key
                }),
                new BarOpt("in", "属于", "select", {
                    dataFetch, storeKey: 'sysDictList_' + key,
                    multiple: true
                }),
                new BarOpt("notIn", "不属于", "select", {
                    dataFetch, storeKey: 'sysDictList_' + key,
                    multiple: true
                }),
                new BarOpt("isNull","为空","select",{disabled: true},false),
                new BarOpt("notNull","不为空","select",{disabled: true},false)
            ],
            inputAttr:{
                dataFetch: function (key) {
                    return (_dict || []).map(e => new SelectOption(e.label, e.value));
                }, storeKey: 'sysDict_' + key
            }
        }
    },
    sysDictList(key) {
        let dataFetch = sysDictDataFetch.call(this,key);
        return {
            name: "ElSelectBar",
            title: '系统字典多值包含搜索' + key,
            optList: [
                new BarOpt("contains", "包含", "select", {
                dataFetch, storeKey: 'sysDict_' + key,
                multiple: true
                }),
                new BarOpt("notContains", "不包含", "select", {
                    dataFetch, storeKey: 'sysDict_' + key,
                    multiple: true
                }),
                new BarOpt("isNull","为空","select",{disabled: true},false),
                new BarOpt("notNull","不为空","select",{disabled: true},false),
                new BarOpt("equals", "等于", "select",  {
                    dataFetch, storeKey: 'sysDict_' + key
                }),
                new BarOpt("notEquals", "不等于", "select",  {
                    dataFetch, storeKey: 'sysDict_' + key
                }),],

            inputAttr:{
                dataFetch, storeKey: 'sysDict_' + key,
                multiple: true
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/table/model/barOption.js